import { render } from "./zcfzTable2.vue?vue&type=template&id=dd194c8c&scoped=true"
import script from "./zcfzTable2.vue?vue&type=script&lang=js"
export * from "./zcfzTable2.vue?vue&type=script&lang=js"

import "./zcfzTable2.vue?vue&type=style&index=0&id=dd194c8c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd194c8c"]])

export default __exports__